import { useCallback } from 'react';
import { salaryCompensationCRUD } from '../services/salaryCompensation';

const useSalaryCompensationCRUD = (callMessage) => {

   const processIndent = useCallback(async (selectedMode, editSalaryID, requestBody) => {
           try {               
   
               const successMessage = selectedMode === 0
                   ? (editSalaryID !== 0
                       ? 'Salary Compensation Updated Successfully'
                       : 'New Salary Compensation Created Successfully')
                   : 'Issued indent Approved Successfully';
   
               // Await the API response
               const data = await salaryCompensationCRUD(requestBody);
   
               if (data?.length > 0) {
                   callMessage('info', successMessage, 'info');
               } else {
                   callMessage('error', 'No data received from API', 'Error');
               }
           } catch (error) {
               callMessage('error', error.message || 'An unexpected error occurred', 'Error');
           }
       }, [callMessage]);
   
       return { processIndent };

}
export default useSalaryCompensationCRUD;